export const mockResponse = {
    data: {
        PolicyHolder: {
            DocumentNumber: "1010354654",
            DocumentType: "C",
            FirstName: "Valenciacc",
            LastName: "Valenciacc",
            Mail: "sad@gmail.com",
            MobilePhone: "3502641212"
        },
        Property: {
            Address: "cl 33a No Tr 31-18",
            CityProperty: "Chinchina",
            TemporaryContracted: "6 meses",
            ContractStartDate: "15/01/2025",
            ContractEndDate: "15/01/2026 ",
            RentalFee: "1.000.000,00",
            AdministrationValue: "100.000,00",
            RealEstateLicensePlate: "56-5158787888"
        },
        Tenant: {
            DocumentNumber: "80401342",
            DocumentType: "C",
            FirstName: "ALfredo",
            LastName: "SEPULVEDA",
            Mail: "",
            MobilePhone: "3146097775",
            SecondLastName: "",
            SecondName: ""
        },
        TotalAmount: 362697.00,
        TotalSumInsured: 362699.00
    },
    error: false
}
// errores de mock resume pantalla 1
export const mockResponseError = {
    data: {
        quoteId: "0Q0dq00000021CvCAI",
        message: "La cotización no existe 3"
    },
    error: true
}

export const mockResponseError2 = {
    data: {
        quoteId: "0Q0dq0000004aB8CAQ",
        message: "La matricula ya cuenta con una póliza activa",
        LeadId: "0R123dq000000463TSF",
        leadRequirement: "Cúmulo retoma proceso inquilino"
    },
    error: true
}

export const mockResponseError3 = {
    data: {
        quoteId: "0Q0dq0000004aB8CAQ",
        message: "El documento del inquilino cuenta con el límite permitido de pólizas activas (2)",
        LeadId: "0R123dq000000463TSF",
        leadRequirement: "Políticas Inquilino"
    },
    error: true
}

export const mockResponseError4 = {
    data: {
        quoteId: "0Q0dq0000004aB8CAQ",
        message: "El documento del propietario cuenta con el límite permitido de pólizas activas (5)",
        leadRequirement: "Política Propietario"
    },
    error: true
}

export const mockotpresume404 = {
    data: {
        quoteId: "0Q0dq0000004lwPCAQ",
        message: "Error 400 del servidor",
        ApplicationId: 3945751
    },
    error: true
}
